import { Button } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router'
import { UIDialog } from 'src/components/ui/Modal'
import IcBaselineInstallMobile from '~icons/ic/baseline-install-mobile'
import IcOutlineContactSupport from '~icons/ic/outline-contact-support'
import { openAppDownloadDialog } from '../AppDownload'
import { MioExpression, MioImage } from '../Common/MioImage'
import MarkdownRenderer from '../ui/MarkdownRenderer'

/** Flag to determine if there's at least one payment method available */
export function isPaymentAvailable() {
  return true
}

export type MembershipPaymentUnavailableNoticeConfig =
  | { type: 'unavailable' }
  | { type: 'unavailable-still-active' }
  | { type: 'one-time-membership'; expiresAt: string }

export function MembershipPaymentUnavailableNotice({
  config,
}: {
  config: MembershipPaymentUnavailableNoticeConfig
}) {
  const { t } = useTranslation(['common', 'membership'])
  const keyPrefix = `membership:${config.type}-notice`
  return (
    <div className="p-8 flex flex-col">
      <h1 className="font-bold text-2xl">{t(`${keyPrefix}.title`)}</h1>
      <MioImage
        expression={MioExpression.Cry}
        className="self-center max-h-[240px]"
      />
      <MarkdownRenderer as="article" className="mt-4 [&>p]:my-2">
        {t(
          `${keyPrefix}.description`,
          config.type === 'one-time-membership'
            ? { expiresAt: config.expiresAt }
            : {},
        )}
      </MarkdownRenderer>
      <section className="flex items-center gap-2 mt-6">
        <Button
          variant="contained"
          startIcon={<IcBaselineInstallMobile />}
          className="bg-violet-600 text-white"
          onClick={() => {
            openAppDownloadDialog({ hideAndroidFilterFree: true })
          }}
        >
          {t('common:app-download-dialog.title')}
        </Button>
        <Button
          component={Link}
          variant="contained"
          to={t('membership:unavailable-notice.contact-support.link')}
          target="_blank"
          rel="noreferer"
          startIcon={<IcOutlineContactSupport />}
          className="ml-auto"
        >
          {t('membership:unavailable-notice.contact-support.label')}
        </Button>
      </section>
    </div>
  )
}

export async function openMembershipPaymentUnavailableNotice(
  config: MembershipPaymentUnavailableNoticeConfig,
) {
  await UIDialog.create({
    dismissable: true,
    className: 'w-fit max-w-screen-msm',
    children: <MembershipPaymentUnavailableNotice config={config} />,
  })
}
